import Grid from '@mui/material/Unstable_Grid2';
import { Stack } from '@mui/system';

export const Missao = () => {
    return(

        <div style={{ padding: '85px 0 0'}} id="missao-top">
            
            <Stack >
                <h2>Nossa Missão</h2>
            </Stack>
            <div id='missao'>
                {/* <div className='overlay'> */}
                        <Grid container
                            spacing={0} 
                            display="flex" 
                            columns={{ xs: 4, sm: 8, md: 12 }}
                        >
                            <Grid 
                                display="flex" 
                                justifyContent="center" 
                                xs={4} sm={8} md={12} 
                            >
                                <Stack >
                                    <div id="missaoText">
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <h3 style={{padding:"40px" }}>Prover soluções de engenharia<br />seguras e sustentáveis,<br />fundamentadas em inovação tecnológica,<br />para contribuir com o desenvolvimento e o bem-estar<br />de toda a sociedade.</h3>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>
                                        <br/>

                                    </div>
                                </Stack>
                            </Grid>
                        </Grid>
                        <br />
                {/* </div> */}
            </div>

        </div>

    )
}